import colors from './colors'

const theme = {
	colors,
}

export type Theme = typeof theme

export default theme
